import { useState } from 'react'
import { Props } from './Layout'
import { useLoginUser } from '../../states/LoginUser'
import { useConvertableJunkQuery, useSwapJunkToArcadePartsMutation } from './query.generated'
import { TerasService } from '@/src/services/TerasService'
export type Params = {
  junkId: string
  onCompleted: () => void
  onClickClose: () => void
}

export const useProps = ({ onCompleted, onClickClose, junkId }: Params): Props => {
  const data = useConvertableJunkQuery({ variables: { id: junkId } }).data
  const [status, setStatus] = useState<Props['status']>('Prepare')
  const terasBalance = useLoginUser().loginUser?.terasBalance ?? 0
  const [numOfConvertItems, setNumOfConvertItems] = useState(1)
  const [swapJunkToArcadeParts] = useSwapJunkToArcadePartsMutation()
  const convertable =
    (data?.junk?.amount ?? 0) >= (data?.junk?.metadata.junksPerPart ?? 0) &&
    terasBalance - TerasService.getDefautlJunkConvertFee() >= 0
  return {
    junk: {
      amount: data?.junk?.amount ?? 0,
      convertedAp: {
        imageUrl: data?.junk?.metadata.arcadePartMetadata.image ?? '',
        name: data?.junk?.metadata.arcadePartMetadata.name ?? '',
      },
      imageUrl: data?.junk?.metadata.image ?? '',
      junksPerPart: data?.junk?.metadata.junksPerPart ?? 0,
      name: data?.junk?.metadata.name ?? '',
      rarity: data?.junk?.metadata.rarity ?? 0,
    },
    onChangeNumOfConvertItems: setNumOfConvertItems,
    numOfConvertItems,
    status,
    fee: TerasService.getDefautlJunkConvertFee(),
    terasBalance,
    onClickClose,
    convertable,
    onClickConvert: async () => {
      setStatus('Loading')
      const { errors } = await swapJunkToArcadeParts({
        variables: {
          input: {
            category: data?.junk?.category,
            subCategory: data?.junk?.subCategory,
            quantity: numOfConvertItems,
          },
        },
      }).catch((errors) => errors)
      if (errors) {
        setStatus('Prepare')
        console.error(errors)
        alert('Error') // TODO
      } else {
        setStatus('Completed')
        onCompleted()
        setTimeout(() => {
          onClickClose()
        }, 5000)
      }
    },
  }
}
